import Balance from "ui/wallet/component/display/Balance/Balance";
import { BalanceProps } from "ui/wallet/component/display/Balance/Balance.types";
import clsx from "clsx";
import usePointsBalance from "./hooks/usePointsBalance";
import { default as config } from "common/config/config";

export interface PointsBalanceProps extends Omit<BalanceProps, "units" | "balance"> {
    className?: string;
    style?: React.CSSProperties;
    showUnits?: boolean;
    balance: string | undefined;
}

export default function PointsBalance({
    className,
    showUnits,
    balance: balanceProp = "0",
    isLoading: isLoadingProp,
    ...rest
}: PointsBalanceProps) {
    const props = usePointsBalance({ balance: balanceProp, isLoading: isLoadingProp });

    return (
        <Balance
            className={clsx("points-balance", className)}
            units={showUnits ? config.tokenNames.points : undefined}
            {...props}
            {...rest}
        />
    );
}
